// Copyright (C) 2013 Minted Inc.
// All Rights Reserved
//
// When the recently viewed flash app failed, we had to reimplement it in
// js/html/css. This had to be done quickly, and the existing recently
// viewed area in the 4-up version of the cat page couldn't quickly be reused.
// Therefore, this version exists to fill the need until we unify interfaces.
//
// See https://wiki.minted.com/index.php/Recently_Viewed

(function (M, Backbone, $, _) {
  'use strict';

  M.View = M.View || {};

  M.View.RecentlyViewedItem = Backbone.View.extend({
    className: 'recentlyViewedItem',
    template: M.Template.RecentlyViewed.Item,

    initialize: function () {
      _.bindAll(this, 'verticallyCenterImg');
      if (!this.$el) {
        this.$el = $(this.el);
      }
    },

    /**
     * Returns the sku's PDP url along with Track API parameters.
     *
     * @param {string} url - The current PDP url
     * @param {string} pageSku - The current PDP sku
     * @param {string} destSku - The sku that is clicked on in the recentlyviewed widget
     * @return {string}
     */
    getTrackingUrl: function(url, pageSku, destSku) {
      var trackingParams = {
        feature: M.GA.TRACK_EVENT_CATEGORY.PDP,
        event: M.GA.TRACK_EVENT_ACTION.RECENTLY_VIEWED_SKU_CLICK,
        original_sku: pageSku,
        destination_sku: destSku
      };
      return M.createTrackRedirectUrl(url, trackingParams);
    },

    render: function () {
      var urlWithTracking = this.getTrackingUrl(
        this.model.get('pdpUrl'),
        this.options.tracking.sku,
        this.model.get('sku')
      );
      var tempVars = this.model.toJSON();
      tempVars.pdpUrl = urlWithTracking;
      this.$el.html(this.template(tempVars));
      this.productPhoto = this.$('img.productPhoto');
      this.productPhoto.load(this.verticallyCenterImg);
      return this;
    },

    verticallyCenterImg: function () {
      var box = this.$('.productPhotoBox');
      var boxHeight = box.height();
      var imgHeight = this.productPhoto.height();
      var imgTopMargin = Math.floor((boxHeight - imgHeight) / 2);
      this.productPhoto.css('margin-top', imgTopMargin);
    }
  });

})(M, Backbone, jQuery, _);
